module.exports = __webpack_public_path__ + "static/media/riskSystemSignalNoiseBeat.6c9a5de8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/riskSystemSignalNoiseBeat.mp3
// module id = 587
// module chunks = 0